/**
 * Shared help content — public entry point (CLARID-UX-2026-06, PR 1).
 *
 * Both render targets import from here:
 *   - `<ModuleIntro>` looks up its entry by module key (PR 3);
 *   - the `/how-to` Help hub iterates `moduleKeys` / `glossaryTermKeys` (PR 4).
 *
 * PR 1 ships content only — no UI consumes this yet.
 */

export type { ModuleKey, GlossaryTermKey } from './keys';
export type { ModuleHelpContent, GlossaryEntry } from './types';

import type { GlossaryTermKey, ModuleKey } from './keys';
import type { GlossaryEntry, ModuleHelpContent } from './types';
import { glossary } from './glossary';
import { helpContent } from './helpContent';

export { helpContent } from './helpContent';
export { glossary } from './glossary';

/** All module keys, in authoring order — for iterating the Help hub. */
export const moduleKeys = Object.keys(helpContent) as ModuleKey[];

/** All glossary term keys, in authoring order. */
export const glossaryTermKeys = Object.keys(glossary) as GlossaryTermKey[];

/** Look up a module's help entry. Returns `undefined` if the key is unknown. */
export function getModuleHelp(key: ModuleKey): ModuleHelpContent | undefined {
  return helpContent[key];
}

/** Look up a glossary term. Returns `undefined` if the key is unknown. */
export function getGlossaryEntry(key: GlossaryTermKey): GlossaryEntry | undefined {
  return glossary[key];
}
